<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Subscriptions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
     
      title: "Subscriptions",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Subscriptions",
          active: true,
        },
      ],
      fields: [
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "referrer",
          sortable: true,
        },
        {
          key: "invoiceNumber",
          sortable: true,
        },
        {
          key: "amount",
          sortable: true,
        },
        {
          key: "created",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
      ],
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      nSubs: [],
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      filter: null,
      filterOn: [],
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      payoutStatus: [
          { value: "Processing", text: "Processing" },
          { value: "Deposited", text: "Deposited" },
      ],
      selectedStatus: "Processing",
      totalMade: 0
    };
  },
  methods: {
      onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getAllSubs(){
        this.nSubs = [];
      await firebase.firestore().collection("subscriptions")
      .orderBy("created", "desc")
    //   .where("status", "==", this.selectedStatus)
      .get().then((dataList)=>{
        // eslint-disable-next-line no-console
                        // console.log(this.selectedStatus);
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
              var amount = singleDoc.data().amount == undefined ? 0 : parseFloat(singleDoc.data().amount) ;
              this.totalMade = this.totalMade + amount;
            var data = {
              id: singleDoc.id,
              created: singleDoc.data().created.toDate().toLocaleDateString("en-US", this.options),
              // cardOwner: singleDoc.data().cardOwner,
              referrer: singleDoc.data().referrer ?? "none",
              invoiceNumber: singleDoc.data().invoiceNumber,
              response: singleDoc.data().response ?? null,
              userId: singleDoc.data().userId,
              userName: singleDoc.data().userName,
              amount: amount,
              status: singleDoc.data().status ?? "N/A",
              reseller: singleDoc.data().reseller ?? null
            }
            itemArray.push(data);
            this.nSubs = itemArray
          })
        }
      })
    }
  },
  computed: {
      rows() {
      return this.nSubs.length;
    },
  },
  mounted() {
    this.getAllSubs();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <div class="row">
        <div class="col-sm-8">
            <b-form-select @change="getAllSubs()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
    </div> -->
    <div v-if="nSubs" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Subscription transactions</h4>
            <div>Total: ${{ totalMade.toFixed(2) }}</div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="nSubs"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(userName)="data">
                <div>
                  <span>{{ data.value }}</span><br />
                  <span style="font-size: 10px; color:blue;">{{ data.item.reseller == null? '': 'reseller' }}</span>
                </div>
              </template>
            </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
